import { ListItemText } from '@mui/material'
import styles from './index.module.scss'

/** @param {{ label: string, isDanger: boolean, isSelected: boolean }} props */
export function FloatingMenuItemLabel({ label, isDanger, isSelected }) {
  return (
    <ListItemText
      primary={label}
      sx={{ margin: 0 }}
      primaryTypographyProps={{
        className: styles.itemLabel,
        variant: 'body2',
        sx: {
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',
          height: '20px',
          lineHeight: '20px',
          fontSize: 'var(--app-font-size-popup)',
          fontWeight: 'var(--app-font-weight-regular)',
          color: isDanger ? 'error.main' : isSelected ? 'text.primary' : 'text.secondary',
          whiteSpace: 'nowrap',
          overflow: 'visible',
          textOverflow: 'clip',
        },
      }}
    />
  )
}
